export const ACTION_TYPE = {
  DETAIL: 'detail',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  OTHER: 'other'
};
